const useMenu = async(slug: string): Promise<object> => {
    const {data: menu} = await useAsyncData(slug, () => {
      return queryCollection("menus").where("slug", "=", slug).first();
    });
  
    return menu?.value?.body || {};
  }
  
  export default useMenu;
  